var firebaseConfig = {
    apiKey: "AIzaSyB8Cba40SFSDCUEh0mugveBknqLeWVcR8c",
    authDomain: "volenter-netword.firebaseapp.com",
    projectId: "volenter-netword",
    storageBucket: "volenter-netword.appspot.com",
    messagingSenderId: "743786832944",
    appId: "1:743786832944:web:7aaa334966457df24b39f5"
  };
  // Initialize Firebase
 export default firebaseConfig;